import createReactComponent from '../createReactComponent';
export default createReactComponent('components-off', 'IconComponentsOff', [
  ['path', { d: 'M3 12l3 3l3 -3l-3 -3z', key: 'svg-0' }],
  ['path', { d: 'M18.5 14.5l2.5 -2.5l-3 -3l-2.5 2.5', key: 'svg-1' }],
  ['path', { d: 'M12.499 8.501l2.501 -2.501l-3 -3l-2.5 2.5', key: 'svg-2' }],
  ['path', { d: 'M9 18l3 3l3 -3l-3 -3z', key: 'svg-3' }],
  ['path', { d: 'M3 3l18 18', key: 'svg-4' }],
]);
